import { render } from "./ShareModal.vue?vue&type=template&id=48291e58"
import script from "./ShareModal.js?vue&type=script&lang=js"
export * from "./ShareModal.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__